import * as prettier from "prettier/standalone"
import * as prettierPluginHtml from "prettier/plugins/html"

export const formatHtml = async (html: string): Promise<string> => {
  const trimmed = html.trim()
  if (!trimmed) return html

  try {
    return await prettier.format(trimmed, {
      parser: "html",
      plugins: [prettierPluginHtml],
      printWidth: 100,
      tabWidth: 2,
      htmlWhitespaceSensitivity: "ignore",
    })
  } catch {
    return html
  }
}
